import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {DataFormatService} from "../../../../services/data-format.service";
import {FormArray, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {DatePipe} from "@angular/common";
import {FundService, UpdateFundOutletCreditMode} from "../../../fund-service.service";
import {debounceTime, distinctUntilChanged} from "rxjs";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";

export interface FundInvestorTable {
  investor_class: string,
  amount: number,
  admission_date: string,
  exit_date: string

}

@Component({
    selector: 'fund-investors',
    templateUrl: './fund-investors.component.html',
    styleUrls: ['./fund-investors.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FundInvestorsComponent {
  @Input() investors:any[] = []
  @Input() classes:any[] = []
  @Input() investorOrgs:any[] = []
  @Input() permissions:any;
  @Output('save') saveForm:EventEmitter<any> = new EventEmitter<any>()
  public investorColumns:string[] = ['investor_class', 'amount', 'admission_date', 'exit_date']
  public editColumns:string[] = ['investor_class', 'amount', 'admission_date', 'exit_date', 'actions']
  public isExpanded:boolean = true;
  public editMode:boolean = false;
  public searchInvestors:any[] = []
  public searchTypes:any[] = []
  public forms:any[];

  constructor(private dataFormat: DataFormatService, private fb: FormBuilder, private datePipe: DatePipe, public fundService: FundService, private _snackBar: MatSnackBar) {

  }
  public getDataSource(investor:any){
    return new MatTableDataSource<FundInvestorTable>(investor)
  }

  public getOrgLink(investor:any){
    let org = {
      name: investor.investor,
      id: investor.id,
      __typename: 'Organization'
    }

    return this.dataFormat.formatLink(org)
  }

  public toggleEdit(){
    this.editMode = !this.editMode;
    if(this.editMode){
      this._setInvestorFields()
    }
  }

  public addInvestor(){
    let controls = new FormGroup({
      id: new FormControl(null),
      name: new FormControl(null),
      fund_investor_id: new FormControl(null),
      is_repeat: new FormControl(false),
      comments: new FormControl(null),
      ownership_id: new FormControl(null),
      investments: new FormArray([
        new FormGroup({
          id: new FormControl(null),
          admission_date: new FormControl(null),
          exit_date: new FormControl(null),
          amount: new FormControl(null),
          investor_class: new FormControl(null),
          ownership_id: new FormControl(null)
        })
      ])
    })
    this.forms.unshift(controls)
  }

  updateInvestment(event:any){
    if(event.value.investor_class==null && event.value.amount==null){
      return;
    }
    let investmentObj = {
      type: "detail",
      id: event.value?.id,
      investor_class: event.value.investor_class.id,
      amount: event.value.amount,
      exit_date: event.value.exit_date !== null ? this.datePipe.transform(event.value.exit_date, 'yyyy-MM-dd') : null,
      ownership_id: event.value.ownership_id ?? null,
      admission_date: event.value.admission_date !==null ? this.datePipe.transform(event.value.admission_date, 'yyyy-MM-dd') : null
    }
    this.saveForm.emit(investmentObj)
  }

  updateInvestor(event:any){
    let objs:any[] = []
    if(event.length===0){
      return;
    }
    if(this.fundService.findDuplicateNames(event).hasDuplicates){
      return this.openSnackBar('Duplicate investors cannot be saved.', 'save-fail');
    }
    for(let evt of event){
      if(evt.value.id===null && evt.value.name===null){
        return;
      }
      let investorObj:any = {
        // type: "investor",
        is_repeat: evt.value.is_repeat,
        id: evt.value.fund_investor_id,
        investorOrg: evt.value.name,
        notes: evt.value.comments,
      }
      let addedInvestments:any = []
      evt.controls.investments.controls.forEach((investment:any) => {
        if(!investment.pristine){
          addedInvestments.push({
            id: investment.value.id ?? null,
            investor_class: investment.value.investor_class.id,
            amount: investment.value.amount,
            ownership_id: null,
            admission_date: investment.value.admission_date !==null ? this.datePipe.transform(investment.value.admission_date, 'yyyy-MM-dd') : null,
            exit_date: investment.value.exit_date !== null ? this.datePipe.transform(investment.value.exit_date, 'yyyy-MM-dd') : null
          })
        }
      })
      if(addedInvestments.length>0){
        investorObj = {...investorObj, investments: addedInvestments}
      }
      objs.push(investorObj)
    }
    this.saveForm.emit(objs)

  }
  deleteInvestment(event:any, form:any){
    if(event.value.id==null){
      form.controls.investments.controls = form.controls.investments.controls.filter((control:FormGroup) => control.value.id !==null)
      return;
    }
    this.fundService.deleteInterestDetail(event.value.id, (response:any) => {

      form.controls.investments.controls = form.controls.investments.controls.filter((control:FormGroup) => control.value.id !== event.value.id)
      let investor = this.investors.find((investor:any) => investor.id === form.controls.id.value)
      investor.investments = investor.investments.filter((investment:any) => investment.id !== event.value.id)
      this.investors = this.investors.map((inv:any) => inv.id === investor.id ? {...investor} : inv)
      this.openSnackBar('Investment removed.', 'save-success')
    })
  }

  deleteInvestor(event:any){
    if(event.value.id===null){
      this.forms = this.forms.filter((form:FormGroup) => form.value.id!==null);
      return;
    }
    this.fundService.deleteOwnershipInterest(event.value.fund_investor_id, event.value.ownership_id, (response:any) => {
      this.forms = this.forms.filter((form:FormGroup) => form.value.id!==event.value.id)
      this.fundService.updateInvestors({id: event.value.id},null, 'delete')
      this.openSnackBar('Investor removed.', 'save-success')
    })
  }

  public addInvestment(form:any){
    let newForm = new FormGroup({
      id: new FormControl(null),
      admission_date: new FormControl(null),
      exit_date: new FormControl(null),
      amount: new FormControl(null),
      investor_class: new FormControl(null),
      ownership_id: new FormControl(form.value.ownership_id)
    })
    form.controls.investments.controls.push(newForm)
  }

  public searchInvestorOrgs(form:any){
    form.controls.name.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe((value:string) => {
      this.fundService.getOrgSearch(value, (response:any)=>{
        let investorsArray:any[] = []
        for(let s = 0; s < response.data.search_organizations.data.length; s++){
          let isInvestorOrg = response.data.search_organizations.data[s].entity.entity_types.find((type:any) => type.type.name == 'Investor');
          if(isInvestorOrg){
            investorsArray.push(response.data.search_organizations.data[s])
          }
        }
        this.searchInvestors = investorsArray;
        this.searchInvestors = [...this.searchInvestors].sort((a:any, b:any) => a.name.localeCompare(b.name))
      })
    });
  }

  public searchInvestorType(form:any){
    this.searchTypes = []
    form.controls.investor_class.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe((value:string) => {
      if(value.length>0){
        this.searchTypes = this.classes.filter((class$:any) => class$.name.toLowerCase().includes(value.toLowerCase()))
      }
    })
  }

  private _setInvestorFields(){
    this.forms = [];
    for(let i = 0; i < this.investors.length; i++){
      let formArray:any = [];
      for(let g = 0; g < this.investors[i].investments.length; g++){
        let exitDate = this.investors[i].investments[g].exit_date !== null ? new Date(this.investors[i].investments[g].exit_date.split("-").join("/")) : null;
        let admissionDate = this.investors[i].investments[g].admission_date !== null ? new Date(this.investors[i].investments[g].admission_date.split("-").join("/")) : null;
        let investmentControl = new FormGroup({
          id: new FormControl(this.investors[i].investments[g].id),
          investor_class: new FormControl(this.investors[i].investments[g].investor_class),
          amount: new FormControl(this.investors[i].investments[g].amount),
          admission_date: new FormControl(admissionDate),
          exit_date: new FormControl(exitDate),
        })
        formArray.push(investmentControl)
      }
      let controls = new FormGroup({
        id: new FormControl(this.investors[i].id),
        name: new FormControl(this.investors[i].investor),
        fund_investor_id: new FormControl(this.investors[i].fund_investor_id),
        is_repeat: new FormControl(this.investors[i].is_repeat),
        comments: new FormControl(this.investors[i].comments),
        ownership_id: new FormControl(this.investors[i].ownership_id),
        investments: new FormArray(formArray)
      })
      this.forms.push(controls)
    }
  }

  public displayVal(option:any): string {
    if(option === null){
      return ''
    }
    if(typeof option === "string"){
      return option;
    }
    return option.name

  }

  private openSnackBar(message: string, panel_class:string) {
    const config = new MatSnackBarConfig();
    config.panelClass = panel_class !== null ? [panel_class] : ['save-success'];
    config.horizontalPosition = "center";
    config.verticalPosition = "top";
    config.duration = 3000;
    this._snackBar.open(message, 'Ok', config);
  }

}
